app.controller(
    'AdminUserCreationController', ['$scope', '$rootScope', '$http', '$state', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'AdminService', '$sce', '$translate',  AdminUserCreationController]
);

function AdminUserCreationController($scope, $rootScope, $http, $state, $stateParams, $timeout, toastr, $document, Configuration, AdminService, $sce, $translate) {
    var vm = this;

    $scope.UserInfos = {
        UserDefaultLang: {},
        RoleList: [{ name: '' }, { name: '' }, { name: '' }, { name: '' }, { name: '' }],
        NewPassword2: '',
        AssociatedZoneList: [{ name: '' }, { name: '' }, { name: '' }, { name: '' }, { name: '' }],        
    }

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface);

    $scope.config = {
        setHeight: 500
    };

    initController();

    function initController() {
        GetAdminUserInfoForCreation();
    }

    function GetAdminUserInfoForCreation() {
        AdminService.GetAdminUserInfoForCreation()
            .then(function (user) {
                $scope.UserInfos = user.data;
                $scope.updateFieldTags();
            });
    }

    $scope.updateFieldTags = function () {

        $scope.$emit('updateFieldTags');
    };

    vm.CreateUser = function (userInfos) {                        
        emailTitle = $translate.instant("BienvenueEmailTitle", {}, undefined, userInfos.UserLangForInterfaceObj.LangageId);
        AdminService.CreateUser(userInfos, emailTitle)
        .then(
                function success(data) {
                    $rootScope.RedirectFromUserCreation = true;
                    $state.go('app.admin-liste-utilisateur', { lang: $rootScope.LangForInterface });
                },
                function error(data) {
                    alert(data);
                });
    }

    vm.ExecuteAdminTool = function () {
        AdminService.ExecuteAdminTool().
        then(function (data) {            
        },
            function (data) {
            }
        );
    }

}